import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdDisplay02 = (props) => {
  return <LSBdDisplay02Wrapper {...props} />;
};

export default LSBdDisplay02;

const LSBdDisplay02Wrapper = styled(LineSeedKrBd)`
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  letter-spacing: -0.6px;

  color: #222222;
`;
